import React, { useRef, useEffect } from 'react';
import ReactSummernote from 'react-summernote';
import 'react-summernote/dist/react-summernote.css'; // import styles
import 'summernote/dist/summernote-bs4';
import '@fortawesome/fontawesome-free/css/all.css'; // Import FontAwesome
// Import bootstrap(v3 or v4) dependencies
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/dist/css/bootstrap.css';
import $ from 'jquery';
import jQuery from 'jquery';

const Editor = (props) => {
    const editorRef = useRef(null);

    // Thêm function để tạo searchable dropdown
    const addSearchableDropdown = () => {
        // Thêm CSS cho searchable dropdown
        const style = document.createElement('style');
        style.textContent = `
            .note-fontname .dropdown-menu {
                max-height: 300px;
                overflow-y: auto;
            }
            .font-search-input {
                width: 100%;
                padding: 8px;
                border: 1px solid #ccc;
                border-radius: 4px;
                margin-bottom: 5px;
                font-size: 12px;
            }
            .font-search-input:focus {
                outline: none;
                border-color: #007bff;
            }
            .dropdown-item.hidden {
                display: none !important;
            }
        `;
        document.head.appendChild(style);
    };

    useEffect(() => {
        addSearchableDropdown();

        // Alternative approach - simpler
        const addSearchToDropdown = () => {
            $(document).on('shown.bs.dropdown', '.note-fontname', function() {
                const $dropdown = $(this).find('.dropdown-menu');

                if (!$dropdown.find('.font-search-input').length) {
                    const searchInput = $('<input type="text" class="font-search-input" placeholder="Tìm kiếm font..." style="width:100%;padding:8px;margin:5px;border:1px solid #ccc;border-radius:4px;">');
                    $dropdown.prepend(searchInput);

                    searchInput.on('input', function() {
                        const searchTerm = $(this).val().toLowerCase();
                        $dropdown.find('.dropdown-item').not(this).each(function() {
                            const text = $(this).text().toLowerCase();
                            $(this).toggle(text.includes(searchTerm));
                        });
                    });

                    searchInput.on('click', function(e) {
                        e.stopPropagation();
                    });

                    setTimeout(() => searchInput.focus(), 50);
                }
            });
        };

        addSearchToDropdown();

        return () => {
            $(document).off('shown.bs.dropdown', '.note-fontname');
        };
    }, []);

    const onImageUpload = (files) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (editorRef.current) {
                editorRef.current.editor.summernote('insertImage', reader.result, ($image) => {
                    $image.css("width", Math.floor($image.width() / 2));
                    $image.attr("alt", files[0].name);
                });
            }
        };
        reader.readAsDataURL(files[0]);
    };
    const onChange = (content) => {
        //   console.log('onChange', content);
        if (props.onChange) {
            try {
                const target = {name: props.name, value:content};
                props.onChange({target});
            } catch (error) {
                console.warn('onChange error prevented:', error);
            }
        }
    };

    if(props && props.readonly && props.readonly ==='readonly')
    {
        return (
            <div style={{ marginTop: '20px', border: '1px solid #ccc', padding: '10px' }}
                 dangerouslySetInnerHTML={{ __html:   props.value }}>

            </div>
        )
    }

    console.log(props.name +' ' +props.value);
    return (
        <ReactSummernote
            id ={props.name}
            name ={props.name}
            ref={editorRef}
            value={props.value }
            options={{
                height: 150,
                dialogsInBody: true,
                // Fix lỗi Range selection
                followingToolbar: false,
                disableDragAndDrop: true,
                // Thêm danh sách font tùy chỉnh
                fontNames: [
                    'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New',
                    'Helvetica Neue', 'Helvetica', 'Impact', 'Lucida Grande',
                    'Tahoma', 'Times New Roman', 'Verdana', 'Georgia',
                    'Palatino', 'Garamond', 'Bookman', 'Trebuchet MS',
                    'Arial Narrow', 'Brush Script MT', 'Lucida Sans Unicode',
                    'Times', 'serif', 'sans-serif', 'monospace', 'cursive', 'fantasy',
                    // Thêm các font Google Fonts phổ biến
                    'Roboto', 'Open Sans', 'Lato', 'Montserrat', 'Oswald',
                    'Source Sans Pro', 'Raleway', 'PT Sans', 'Lora', 'Merriweather'
                ],
                // Cho phép thêm font tùy chỉnh
                fontNamesIgnoreCheck: [
                    'Roboto', 'Open Sans', 'Lato', 'Montserrat', 'Oswald',
                    'Source Sans Pro', 'Raleway', 'PT Sans', 'Lora', 'Merriweather'
                ],
                toolbar: [
                    ['style', ['style']],
                    ['font', ['bold', 'underline', 'clear', 'fontsize']],
                    ['fontname', ['fontname']],
                    ['color', ['color']], // Add color button group
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture', 'video']],
                    ['view', ['fullscreen', 'codeview']]
                ],
                // Thêm callbacks để handle lỗi
                callbacks: {
                    onInit: function() {
                        // Đảm bảo editor khởi tạo đúng
                        console.log('Summernote initialized');

                        // Thêm search functionality sau khi init
                        setTimeout(() => {
                            const $editor = $(editorRef.current.editor);

                            // Custom font dropdown với search
                            $editor.on('summernote.dropdown.show', function(e) {
                                const $dropdown = $(e.target).find('.note-fontname .dropdown-menu');
                                if ($dropdown.length && !$dropdown.find('.font-search-input').length) {
                                    const searchInput = $('<input type="text" class="font-search-input" placeholder="Tìm kiếm font..." autocomplete="off">');
                                    $dropdown.prepend(searchInput);

                                    searchInput.on('input', function() {
                                        const searchTerm = $(this).val().toLowerCase();
                                        const items = $dropdown.find('.dropdown-item').not(this);

                                        items.each(function() {
                                            const text = $(this).text().toLowerCase();
                                            $(this).toggle(text.includes(searchTerm));
                                        });
                                    });

                                    searchInput.on('click', function(e) {
                                        e.stopPropagation();
                                    });

                                    setTimeout(() => searchInput.focus(), 50);
                                }
                            });
                        }, 500);
                    },
                    onKeyup: function(e) {
                        // Prevent range errors
                        try {
                            const content = $(this).summernote('code');
                            // Trigger onChange nếu có
                            if (typeof onChange === 'function') {
                                onChange(content);
                            }
                        } catch (error) {
                            console.warn('Range error prevented:', error);
                        }
                    }
                }
            }}
            onImageUpload={onImageUpload}
            onChange={onChange}
        />
    );
};

export default Editor;